var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWamClientLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "130.000000pt",
    height: "37.000000pt",
    viewBox: "0 0 130.000000 37.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,37.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 328 c8 -24 35 -107 60 -186 l46 -143 47 3 47 3 32 90 c17 50 33 94 35 99 3 6 20 -35 40 -90 l35 -99 46 -3 45 -3 57 173 c32 95 60 179 63 186 3 9 -11 12 -50 12 l-54 0 -24 -92 c-37 -135 -40 -136 -78 -13 l-34 105 -44 0 -44 0 -32 -105 c-18 -58 -35 -105 -38 -105 -3 0 -18 47 -34 105 l-29 105 -53 0 -53 0 14 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551 202 c-30 -92 -56 -175 -59 -184 -4 -15 3 -18 45 -18 l50 0 28 95 c15 53 32 92 37 87 4 -4 21 -46 36 -93 l29 -84 51 -3 51 -3 -40 113 c-21 62 -51 146 -65 186 l-26 72 -42 0 -41 0 -54 -168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809 288 l-32 -81 23 -68 c12 -38 27 -66 31 -63 5 2 16 29 25 59 10 30 20 55 24 55 3 0 19 -42 36 -92 l30 -93 51 -3 51 -3 32 96 c17 52 35 93 39 91 4 -3 20 -45 36 -95 l29 -91 52 0 52 0 -61 185 -62 186 -45 -3 -44 -3 -31 -95 c-16 -52 -35 -96 -40 -98 -5 -2 -25 42 -43 97 l-34 101 -43 0 -43 0 -33 -82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 87 c-8 -19 -2 -31 13 -26 5 2 6 13 2 24 -7 19 -8 19 -15 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWamClientLogo);
export default __webpack_public_path__ + "static/media/wam-client-logo.bc4238819e9800900bc24bf1d99efcb4.svg";
export { ForwardRef as ReactComponent };